import { useLocation, useNavigate } from "react-router-dom"
import useGlobalContext from "../context/GlobalContext"
import { motion } from "framer-motion"

const Menu = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { changeCursor, showMenu, setShowMenu } = useGlobalContext()

  const nav = {
    open: { y: 0, transition: { duration: 0.35 } },
    closed: {
      y: "-100%",
      transition: { duration: 0.35, delay: 0.4 },
    },
  }

  const variants = {
    open: {
      transition: {
        staggerChildren: 0.07,
        delayChildren: 0.2,
      },
    },
    closed: {
      transition: {
        staggerChildren: 0.05,
        staggerDirection: -1,
      },
    },
  }

  const link = {
    open: {
      y: 0,
      opacity: 1,
      transition: {
        y: { stiffness: 1000, velocity: -100 },
      },
    },
    closed: {
      y: 50,
      opacity: 0,
      transition: {
        y: { stiffness: 1000 },
      },
    },
  }

  return (
    <motion.nav
      variants={nav}
      initial="closed"
      animate={showMenu ? "open" : "closed"}
      className={`nav`}
    >
      <motion.div className="nav-header">
        <h2 className="select-none uppercase logo f-light">PixieAutumn</h2>
        <motion.button
          onClick={() => setShowMenu(false)}
          onMouseEnter={() => changeCursor("btn-hover")}
          onMouseLeave={() => changeCursor("")}
          className="btn menu-btn uppercase pointer"
        >
          Close
        </motion.button>
      </motion.div>
      <motion.ul className="nav-links" variants={variants}>
        <motion.li
          variants={link}
          onMouseEnter={() => changeCursor("hovered")}
          onMouseLeave={() => changeCursor("")}
          className={`nav-link uppercase ${
            location.pathname === "/" ? "active" : ""
          }`}
          onClick={() => {
            navigate("/")
            setShowMenu(false)
          }}
        >
          <span>01</span> Home
        </motion.li>
        <motion.li
          variants={link}
          onMouseEnter={() => changeCursor("hovered")}
          onMouseLeave={() => changeCursor("")}
          className={`nav-link uppercase ${
            location.pathname === "/work/all" ? "active" : ""
          }`}
          onClick={() => {
            navigate("/work/all")
            setShowMenu(false)
          }}
        >
          <span>02</span> All Works
        </motion.li>
        <motion.li
          variants={link}
          onMouseEnter={() => changeCursor("hovered")}
          onMouseLeave={() => changeCursor("")}
          className={`nav-link uppercase ${
            location.pathname === "/about" ? "active" : ""
          }`}
          onClick={() => {
            navigate("/about")
            setShowMenu(false)
          }}
        >
          <span>03</span> About
        </motion.li>
      </motion.ul>
      <div className="nav-footer">
        <p className="uppercase">Director of photography</p>
      </div>
    </motion.nav>
  )
}

export default Menu
